module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header nt-page-header"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button",
      "disabled": !_vm.center.unread
    },
    on: {
      "click": _vm.readAll
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Mark all read\n    ")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "nt-filters"
  }, [_c('div', {
    staticClass: "btn-group"
  }, _vm._l((_vm.views), function(f) {
    return _c('button', {
      key: f.key,
      staticClass: "btn btn-sm",
      class: _vm.view === f.key ? 'btn-primary' : 'btn-default',
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.setView(f.key)
        }
      }
    }, [_vm._v("\n          " + _vm._s(f.label)), (f.key === 'unread' && _vm.center.unread) ? _c('span', [_vm._v(" (" + _vm._s(_vm.center.unread) + ")")]) : _vm._e()])
  }), 0), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control input-sm nt-select",
    on: {
      "change": _vm.reload
    },
    model: {
      value: (_vm.severity),
      callback: function($$v) {
        _vm.severity = $$v
      },
      expression: "severity"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All severities")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "critical"
    }
  }, [_vm._v("Critical")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "warning"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "success"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "info"
    }
  }, [_vm._v("Info")])]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control input-sm nt-select",
    on: {
      "change": _vm.reload
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Templates and campaigns")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "template_"
    }
  }, [_vm._v("Templates")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "campaign_"
    }
  }, [_vm._v("Campaigns")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "nt-list"
  }, [(!_vm.items.length && !_vm.loading) ? _c('div', {
    staticClass: "nt-empty"
  }, [_c('i', {
    staticClass: "fa fa-bell-slash-o"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.view === 'unread' ? "You're all caught up." : 'No notifications match these filters.'))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(n) {
    return _c('div', {
      key: n.id,
      staticClass: "nt-row",
      class: {
        'nt-unread': !n.is_read
      }
    }, [_c('i', {
      staticClass: "fa nt-row-icon",
      class: [_vm.icon(n), ("nt-sev-" + (n.severity))]
    }), _vm._v(" "), _c('div', {
      staticClass: "nt-row-main"
    }, [_c('div', {
      staticClass: "nt-row-top"
    }, [_c('strong', [_vm._v(_vm._s(n.title))]), _vm._v(" "), _c('span', {
      staticClass: "nt-chip",
      class: ("nt-chip-" + (n.severity))
    }, [_vm._v(_vm._s(n.severity))])]), _vm._v(" "), (n.body) ? _c('p', {
      staticClass: "nt-row-body"
    }, [_vm._v(_vm._s(n.body))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.proposalsOf(n)), function(p, i) {
      return _c('div', {
        key: i,
        staticClass: "nt-proposal"
      }, [_c('div', {
        staticClass: "nt-proposal-head"
      }, [_vm._v("Proposed change · " + _vm._s(p.name) + " (" + _vm._s(p.language) + ")")]), _vm._v(" "), (p.problems && p.problems.length) ? _c('ul', {
        staticClass: "nt-proposal-problems"
      }, _vm._l((p.problems), function(problem, j) {
        return _c('li', {
          key: j
        }, [_vm._v(_vm._s(problem))])
      }), 0) : _vm._e(), _vm._v(" "), (p.why) ? _c('p', {
        staticClass: "nt-proposal-why"
      }, [_vm._v(_vm._s(p.why))]) : _vm._e(), _vm._v(" "), (p.proposed) ? _c('div', {
        staticClass: "nt-diff"
      }, [_c('div', {
        staticClass: "nt-diff-col nt-diff-old"
      }, [_c('span', [_vm._v("Now")]), _c('pre', [_vm._v(_vm._s(p.current))])]), _vm._v(" "), _c('div', {
        staticClass: "nt-diff-col nt-diff-new"
      }, [_c('span', [_vm._v("Proposed "), _c('button', {
        staticClass: "btn btn-xs btn-default nt-copy",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.copy(p.proposed)
          }
        }
      }, [_vm._v(_vm._s(_vm.copied === p.proposed ? 'Copied' : 'Copy'))])]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(p.proposed))])])]) : (!p.problems || !p.problems.length) ? _c('p', {
        staticClass: "nt-proposal-why"
      }, [_vm._v("No change could be suggested automatically. Review the template against WhatsApp's rules.")]) : _vm._e(), _vm._v(" "), (_vm.resubmittedOf(n, p)) ? _c('p', {
        staticClass: "nt-resubmitted"
      }, [_c('i', {
        staticClass: "fa fa-check-circle"
      }), _vm._v(" Resubmitted as "), _c('strong', [_vm._v(_vm._s(_vm.resubmittedOf(n, p).newName))]), _vm._v(" by " + _vm._s(_vm.resubmittedOf(n, p).by) + ". Campaigns using it can be resumed once WhatsApp approves it.\n            ")]) : (_vm.canResubmit(n)) ? [(!_vm.editorFor(n, p)) ? _c('button', {
        staticClass: "btn btn-xs btn-success nt-accept",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.openEditor(n, p)
          }
        }
      }, [_vm._v("Accept and resubmit…")]) : _c('div', {
        staticClass: "nt-editor"
      }, [_c('label', [_vm._v("New body (sent to WhatsApp as a new version; the campaigns follow it)")]), _vm._v(" "), _c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.editorFor(n, p).body),
          expression: "editorFor(n, p).body"
        }],
        staticClass: "form-control",
        attrs: {
          "rows": "4"
        },
        domProps: {
          "value": (_vm.editorFor(n, p).body)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.editorFor(n, p), "body", $event.target.value)
          }, function($event) {
            return _vm.syncSamples(n, p)
          }]
        }
      }), _vm._v(" "), _vm._l((_vm.editorFor(n, p).samples), function(sample, k) {
        return _c('div', {
          key: k,
          staticClass: "nt-sample"
        }, [_c('label', {
          domProps: {
            "textContent": _vm._s(_vm.sampleLabel(k))
          }
        }), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.editorFor(n, p).samples[k]),
            expression: "editorFor(n, p).samples[k]"
          }],
          staticClass: "form-control input-sm",
          attrs: {
            "placeholder": "A realistic example, in the template's language"
          },
          domProps: {
            "value": (_vm.editorFor(n, p).samples[k])
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(_vm.editorFor(n, p).samples, k, $event.target.value)
            }
          }
        })])
      }), _vm._v(" "), (_vm.editorFor(n, p).error) ? _c('p', {
        staticClass: "nt-editor-error"
      }, [_vm._v(_vm._s(_vm.editorFor(n, p).error))]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "nt-editor-actions"
      }, [_c('button', {
        staticClass: "btn btn-sm btn-success",
        attrs: {
          "type": "button",
          "disabled": _vm.editorFor(n, p).busy
        },
        on: {
          "click": function($event) {
            return _vm.resubmit(n, p)
          }
        }
      }, [(_vm.editorFor(n, p).busy) ? _c('i', {
        staticClass: "fa fa-spinner fa-spin"
      }) : _vm._e(), _vm._v(" Resubmit to WhatsApp\n                  ")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-sm btn-default",
        attrs: {
          "type": "button",
          "disabled": _vm.editorFor(n, p).busy
        },
        on: {
          "click": function($event) {
            return _vm.closeEditor(n, p)
          }
        }
      }, [_vm._v("Cancel")])])], 2)] : _vm._e()], 2)
    }), _vm._v(" "), (n.details && n.details.appealUrl) ? _c('a', {
      staticClass: "nt-appeal",
      attrs: {
        "href": n.details.appealUrl,
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link"
    }), _vm._v(" Request a review or appeal in WhatsApp Manager\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "nt-row-meta"
    }, [_c('span', [_vm._v(_vm._s(_vm.ago(n.created_at)))]), _vm._v(" "), (_vm.countriesOf(n)) ? _c('span', [_vm._v("· " + _vm._s(_vm.countriesOf(n)))]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
      staticClass: "nt-row-actions"
    }, [(n.link) ? _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openItem(n)
        }
      }
    }, [_vm._v("Open")]) : _vm._e(), _vm._v(" "), (!n.is_read) ? _c('button', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.markRead(n)
        }
      }
    }, [_vm._v("Mark read")]) : _vm._e()])])
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "nt-loading"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Loading…")]) : _vm._e(), _vm._v(" "), (_vm.hasMore && !_vm.loading) ? _c('button', {
    staticClass: "btn btn-default btn-sm nt-more",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v("Load older")]) : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Notifications")]), _vm._v(" "), _c('p', {
    staticClass: "nt-page-sub"
  }, [_vm._v("Template status changes from WhatsApp and what they meant for your campaigns.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-57374748","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications/NotificationsPage.vue
// module id = rqnw
// module chunks = 1